import { JSX } from "react";

export default function Cover(): JSX.Element {
    return (
        <section className="hero d-flex flex-column justify-content-center align-items-center">
            <div className="container">
                <h1 className="display-4 fw-bold">M&S AS GARAGE</h1>
                <p className="lead">Twoje auto w dobrych rękach.</p>
                <a href="/form" target="_blank" className="btn btn-primary mt-3">Zapisać
                    się na wizytę</a>
            </div>
        </section>
    );
};